import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'era-panel-footer',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './panel-footer.component.html',
})
export class PanelFooterComponent {}
